module.exports = __webpack_public_path__ + "img/DE00967.677b2b04.png";